import script from "./SearchDrawer.vue?vue&type=script&setup=true&lang=js"
export * from "./SearchDrawer.vue?vue&type=script&setup=true&lang=js"

import "./SearchDrawer.vue?vue&type=style&index=0&id=a3ae514e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a3ae514e"]])

export default __exports__